<template>
  <div class="AppExtension">
    <div class="home-button" v-if="isHome" @click="toHome">
      <img src="@/assets/img/mobileImg/toIndex.png" alt="" />
    </div>
    <div v-if="!isShelves">
      <EndOfRegistration v-if="ismeeting" />
      <OnlineReading v-if="isReading" />
      <BuyButton v-if="$route.query.type == 2 && payUrl()" />
      <Hoarding v-if="isHot" />
    </div>
  </div>
</template>

<script>
import Hoarding from "@/views/mobileView/detail/components/Hoarding.vue";
import BuyButton from "@/views/mobileView/detail/components/BuyButton.vue";
// import RegistrationBegan from '@/views/mobileView/detail/components/RegistrationBegan.vue'
import EndOfRegistration from "@/views/mobileView/detail/components/EndOfRegistration.vue";
import OnlineReading from "@/views/mobileView/detail/components/OnlineReading.vue";
export default {
  name: "AppExtension",
  components: {
    Hoarding,
    // RegistrationBegan,
    BuyButton,
    EndOfRegistration,
    OnlineReading,
  },
  inject: ["payUrl"],
  props: {
    isShelves: {
      type: Boolean
    }
  },
  data() {
    return {};
  },
  computed: {
    isHot() {
      // 判断右下角组件显影
      let routeName = this.$route.name
      // 需要显示收藏的路由name集合
      let routeNameArr = ['msgDetails','solicitationDetails','meetingDetails','thesisDetail','concentrationDetails','dataDetails']
      // 判断是否是在name集合中
      let isHot = routeNameArr.some(item => item == routeName)
      // const share = this.$route.query.share; // 是否是分享页
      //  return !share && isHot;
       return isHot;
    },
    isReading() {
      // 判断在线阅读显影
      const type = this.$route.query.type;
      const types = type == 0 || type == 6; // 显示在线阅读的文章类型  论文 专著
      return types;

      // const share = this.$route.query.share;
      // if (share) {
      //   return false;
      // } else {
      //   return types;
      // }
    },
    ismeeting() {
      return this.$route.query.type == 8 && !this.$route.query.share;
    },
    isHome() {
      const out = this.$route.query.out;
      return !out;
    },
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    toHome() {
      this.$router.push("/index");
    },
  },
};
</script>

<style scoped lang="scss">
.AppExtension {
  position: fixed;
  z-index: 888;
  bottom: 85px;
  right: 20px;
}
.home-button {
  margin-bottom: 10px;
  width: 45px;
  height: 47px;
  border-radius: 50%;
  overflow: hidden;
  background: white;
  border: 1px solid #2f91ff;
  text-align: center;
  line-height: 54px;
  img {
    width: 22px;
  }
}
</style>
